import React from 'react'
import {
  Box,
  Typography,
  FormControlLabel,
  Switch,
  Link,
} from '@applift/factor'
import { ExternalLink } from '@applift/icons'

import { Action, PixelInfo } from '../../../models/Pixel'

export interface ConversionModelingProps {
  dispatch: React.Dispatch<Action>
  data: PixelInfo
}

export const ConversionModelingSetting = (props: ConversionModelingProps) => {
  const { dispatch, data } = props

  return (
    <>
      <Typography component="h5" variant="bodySmall" weight="demi">
        Conversion Modeling
      </Typography>
      <Typography
        sx={{
          textColor: 'neutral-500',
        }}
      >
        Conversion modeling is a machine learning technique used to attribute
        conversions to ads that may not have received direct clicks or views
        from the same device.
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          sx={{ mr: 4 }}
          checked={data.conversionSetting.crossModelling}
          onChange={e =>
            dispatch({
              type: 'TOGGLE_CROSS_MODELLING',
              //@ts-ignore
              payload: e.target.checked,
            })
          }
          labelPlacement="end"
          control={<Switch size="medium" />}
          label="Cross-Device Modeling (Recommended)"
        />
        <Link
          sx={{ textWeight: 'demi', ml: 8 }}
          Component="button"
          color="primary"
          onClick={() =>
            window.open(
              'https://help.iqm.com/en/articles/7329072-conversion-modeling-how-iqm-uses-machine-learning-to-attribute-conversions',
              '_blank'
            )
          }
        >
          <ExternalLink fontSize={16} sx={{ mr: 4 }} />
          <Typography sx={{ textColor: 'primary-500' }}>
            How It Works
          </Typography>
        </Link>
      </Box>
    </>
  )
}
